document.addEventListener("DOMContentLoaded", () => {
  const nav = document.querySelector(".main-nav");
  const toggle = document.querySelector(".mobile-nav-toggle");
  const sectionHeader = document.querySelector(".section-header");

  if (!nav || !toggle) return;

  // --- Media queries to detect layout / input capability --------------------
  const mqWidth = window.matchMedia("(min-width: 768px)");
  const mqHover = window.matchMedia("(hover: hover) and (pointer: fine)");

  // --- Utilities ------------------------------------------------------------
  const setBodyScrollLock = (locked) => {
    document.body.style.overflow = locked ? "hidden" : "";
  };

  const setHeaderOpenClass = (open) => {
    if (!sectionHeader) return;
    sectionHeader.classList.toggle("section-header--nav-open", !!open);
  };

  // --- Open / Close / Toggle -----------------------------------------------
  const open = () => {
    nav.classList.add("main-nav--active");
    toggle.setAttribute("aria-expanded", "true");
    setHeaderOpenClass(true);
    setBodyScrollLock(true);
  };

  const close = () => {
    nav.classList.remove("main-nav--active");
    toggle.setAttribute("aria-expanded", "false");
    setHeaderOpenClass(false);
    setBodyScrollLock(false);
  };

  const toggleNav = () => {
    nav.classList.contains("main-nav--active") ? close() : open();
  };

  // --- Responsive hard reset on media changes -------------------------------
  const resetResponsiveState = () => {
    // Always force-close and remove any side effects
    close();

    // Defensive: also clear any hover/lock classes a sibling script might set
    document.querySelectorAll(".main-nav__item").forEach((el) => {
      el.classList.remove(
        "main-nav__item--hover-locked",
        "main-nav__item--active-mega"
      );
      el.setAttribute?.("aria-expanded", "false");
    });
  };

  const onMediaChange = () => {
    // If we enter desktop width or hover-capable mode, reset.
    if (mqWidth.matches || mqHover.matches) {
      resetResponsiveState();
    }
  };

  // --- Wire up events -------------------------------------------------------
  toggle.addEventListener("click", (e) => {
    e.preventDefault();
    toggleNav();
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") close();
  });

  // Reset when media conditions change (e.g., rotate tablet, resize window)
  mqWidth.addEventListener("change", onMediaChange);
  mqHover.addEventListener("change", onMediaChange);

  // Defensive cleanups on lifecycle changes
  document.addEventListener("visibilitychange", () => {
    if (document.hidden) close();
  });
  window.addEventListener("pagehide", () => close());
  window.addEventListener("beforeunload", () => close());
});
